module.exports = __webpack_public_path__ + "static/img/kucun.7690f2a5.png";